import { Component, AfterContentInit, OnDestroy } from '@angular/core';
import { PlycaDataService } from '../../../services/plyca.service';
import { Configuration } from '../../conf/app.constants';
import { UIService, generateRandomIdentifier } from '../../ui.service';
import { DossierService } from '../dossier.service';
import { HeaderActionsService } from '../../components/common/sub-header/header-actions.service';
import { WaitLoadingService } from '../../components/common/waitLoading/wait-loading.service';
import { TranslateService } from '@ngx-translate/core';
import { ProfileDTO } from '../../api/plyca-dtos';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng-lts/dynamicdialog';
import { OverlayPanel } from 'primeng-lts/overlaypanel';
import { BaseComponent } from '../../components/common/baseComponent/base.component';

export class DivisionPhaseDTO {
  division: string;
  phase: string;
  description: string;
}

@Component({
  selector: 'procedureMap',
  templateUrl: 'procedureMap.template.html',
  providers: [DialogService]
})
export class ProcedureMapComponent extends BaseComponent implements AfterContentInit, OnDestroy {
  division: string;
  dossierId: string;
  phase: string;
  block: number;
  allProfiles: ProfileDTO[];
  divisionPhases: DivisionPhaseDTO[];

  loadedRules: any[];
  blocks: number[];

  loaded = false;

  windowHash: string;

  selectedRule: any;
  selectedPhaseDivision: DivisionPhaseDTO;
  selectedPhases: DivisionPhaseDTO[];

  notIsFirstPhase: boolean;
  notIsLastPhase: boolean;
  showPhasesButton: boolean;

  constructor(
    public plycaService: PlycaDataService,
    public dossierService: DossierService,
    public headerActionsService: HeaderActionsService,
    public uiService: UIService,
    protected waitService: WaitLoadingService,
    private ref: DynamicDialogRef,
    public configuration: Configuration,
    public config: DynamicDialogConfig,
    protected translate: TranslateService
  ) {
    super();
    this.dossierId = this.config['dossierId'];
    this.division = this.config['division'];
    this.phase = this.config['phase'];
    this.block = this.config['block'];
    this.allProfiles = this.config['allProfiles'];
  }

  ngAfterContentInit(): void {
    this.windowHash = generateRandomIdentifier();
    this.showButtons();
    this.loadDivisions();
  }

  ngOnDestroy(): void {
    this.config = null;
    this.ref = null;
    this.headerActionsService.clearWindowActions(this.windowHash);
    super.ngOnDestroy();
  }

  showButtons(): void {
    this.headerActionsService.clearWindowActions(this.windowHash);
    this.subscribe(this.headerActionsService
      .addWindowAction(
        'Fase Anterior',
        'fas fa-lg fa-step-backward',
        'btn-secondary',
        this.notIsFirstPhase,
        this.windowHash
      ),
      () => {
        let newPhase: DivisionPhaseDTO = this.divisionPhases[this.actualDivIndex() - 1];
        this.division = newPhase.division;
        this.phase = newPhase.phase;
        this.loadRules();
      });
    this.subscribe(this.headerActionsService
      .addWindowAction(
        'Ver Mapa de Fases',
        'fas fa-lg fa-sitemap',
        'btn-primary',
        this.showPhasesButton,
        this.windowHash
      ),
      () => {
        this.division = null;
        this.phase = null;
        this.loadRules();
      });
    this.subscribe(this.headerActionsService
      .addWindowAction(
        'Fase Siguiente',
        'fas fa-lg fa-step-forward',
        'btn-secondary',
        this.notIsLastPhase,
        this.windowHash
      ),
      () => {
        let newPhase: DivisionPhaseDTO = this.divisionPhases[this.actualDivIndex() + 1];
        this.division = newPhase.division;
        this.phase = newPhase.phase;
        this.loadRules();
      });

    this.headerActionsService.addWindowDivider(this.windowHash);

    this.subscribe(this.headerActionsService
      .addWindowAction(
        'General.close',
        'fas fa-lg fa-times',
        'btn-outline-secondary',
        true,
        this.windowHash
      ),
      () => {
        this.cancel();
      });
  }

  public isLoaded() {
    return this.loaded;
  }

  cancel() {
    this.ref.close();
  }

  loadDivisions(): void {
    this.selectedPhaseDivision = null;
    this.divisionPhases = [];
    this.loaded = false;
    this.subscribe(this.plycaService
      .getAttributeValue(
        'DEF_PHASES_PROCEDURE_STD',
        'PROPUESTAID=' + this.dossierId
        + '&LOCALE=' + this.translate.currentLang + "_ES"
      ),
      x => {
        x.values.forEach(element => {
          let division: DivisionPhaseDTO = new DivisionPhaseDTO();
          division.phase = element.columns["FASE_REGLA"].value;
          division.division = element.columns["DIVISION"].value;
          division.description = element.columns["EXPFASEDESCRIP"].value;
          if (division.division != "0")
            division.description += " - " + element.columns["DESC_DIVISION"].value;
          if (division.phase != "0")
            this.divisionPhases.push(division);
        });
        this.loadRules();
      },
      err => {
        console.log('Error cargando datos atributo: DEF_PHASES_PROCEDURE_STD');
        console.log(err);
      }
    );
  }


  loadRules(): void {
    this.selectedPhaseDivision = null;
    this.showPhasesButton = false;
    this.notIsFirstPhase = false;
    this.notIsLastPhase = false;
    if (!this.phase && this.divisionPhases.length > 0) {
      this.showButtons();
      this.loaded = true;
      return;
    }
    this.loaded = false;
    this.subscribe(this.plycaService
      .getAttributeValue(
        'DEF_RULES_PHASE_BLOCK_STD',
        'PROPUESTAID=' + this.dossierId
        + '&DIVISION=' + this.division
        + '&EXP_FASE=' + this.phase
        + '&BLOQUE=' + this.block
        + '&LOCALE=' + this.translate.currentLang + "_ES"
      ),
      x => {
        if (x.values && x.values[0] && x.values[0].columns["JSON_DEF"]) {
          this.loadedRules = JSON.parse(x.values[0].columns["JSON_DEF"].value);
          if (this.loadedRules["rules"])
            this.loadedRules = this.loadedRules["rules"];
          this.loadedRules.forEach((rule: any) => rule.activeProcess = 0);
          this.blocks = this.loadedRules.map(item => item.block)
            .filter((value, index, self) => value >= 0 && self.indexOf(value) === index);
          this.blocks.sort((b1, b2) => { return b1 - b2 });
          this.normalizeTasks();
          this.notIsFirstPhase = this.divisionPhases && this.actualDivIndex() > 0;
          this.notIsLastPhase = this.divisionPhases && this.actualDivIndex() < (this.divisionPhases.length - 1);
          this.showPhasesButton = true;
          this.showButtons();
          this.loaded = true;
        }
      },
      err => {
        console.log('Error cargando datos atributo: DEF_RULES_PHASE_BLOCK_STD');
        console.log(err);
      }
    );
  }

  //Metodo que unifica la informacion de tareas que provienen de estandar lite
  normalizeTasks() {
    //normalizamos tareas basadas en listCircuitStepDTO
    this.loadedRules.filter(x => x.processes.filter(y => y.listCircuitStepDTO).length > 0).forEach(x => {
      x.processes.forEach(z => {
        z.tasks = [];
        z.listCircuitStepDTO.forEach(w => {
          let task = {};
          task["task"] = w["typeStep"] + " " + x.docDescription;
          task["taskType"] = w["typeStep"].substring(0, 1);
          if (w["profile"] && w["profile"]["identifier"])
            task["role"] = w["profile"]["identifier"];
          if (w["inbox"] && w["inbox"]["name"])
            task["mailbox"] = w["inbox"]["name"];
          z.tasks.push(task);
        });
      });
    });
    //convertimos en array los cambios de fase multiples
    this.loadedRules.filter(x => x.params?.phaseChange?.indexOf("[") == 0).forEach(x => {
      x.params["phaseChangeArray"] = eval(x.params.phaseChange);
    });
  }

  getBlockRules(block: string): any[] {
    let rules = this.loadedRules.filter(rule => rule.block === block && rule.mandatory && rule.ruleType != "INTERNAL" && ((rule.executed != "99" && rule.processes && rule.processes.length > 0) || rule.ruleType == "F"));
    return rules;
  }

  getRuleVisibleTasks(rule: any): any[] {
    if (rule.processes && rule.processes[rule.activeProcess] && rule.processes[rule.activeProcess].tasks) {
      let tasks: any[] = rule.processes[rule.activeProcess].tasks.filter((proc: any) => proc.taskType != "T"); //Filtramos la tarea de gestión;
      return tasks;
    } else
      return [];
  }

  getMaxTasksInBlock(block: string): any[] {
    let maxTasks: number = 0;
    this.getBlockRules(block).forEach(aRule => {
      if (this.getRuleVisibleTasks(aRule)
        && this.getRuleVisibleTasks(aRule).length > maxTasks)
        maxTasks = this.getRuleVisibleTasks(aRule).length;
    });
    if (maxTasks == 0)
      maxTasks = 1;
    return new Array(maxTasks);
  }

  getProfileDescription(role: number): string {
    if (!role || !this.allProfiles)
      return "" + role;
    let roleProfile: ProfileDTO = this.allProfiles.find((profile: ProfileDTO) => +profile.identifier == role);
    if (!roleProfile)
      return "" + role;
    return roleProfile.description;
  }

  getTaskName(rule: any, process: any): string {
    if (rule.ruleType == "M" && rule.processes[rule.activeProcess].tasks && rule.processes[rule.activeProcess].tasks.length == 1)
      return this.translate.instant('Tasks.procedureMap.msg') + ": " + rule.description;
    if (rule.processes[rule.activeProcess] && rule.processes[rule.activeProcess].docClass == 'COM_GEN')
      return rule.description;
    return process ? process.task : (rule.processes[rule.activeProcess] ? rule.processes[rule.activeProcess].docDescription : rule.description);
  }

  isPhaseChange(rule: any): boolean {
    return rule.ruleType && rule.ruleType == "F" && rule.params && rule.params.phaseChange;
  }

  isMultiplePhaseChange(rule: any): boolean {
    return this.isPhaseChange(rule) && rule.params.phaseChangeArray && Array.isArray(rule.params.phaseChangeArray);
  }

  showPhaseChangeButton(rule: any): boolean {
    return (this.isPhaseChange(rule) || this.isMultiplePhaseChange(rule)) && (rule.params.phaseChange < 50 || (rule.params?.phaseChangeArray && rule.params.phaseChangeArray.filter(x => x < 50).length > 0));
  }

  changePhase(phaseChangeObj: any, overlaypanel?: OverlayPanel): void {
    if (phaseChangeObj.params && phaseChangeObj.params.phaseChange && !phaseChangeObj.params.phaseChangeArray) {
      //Es una regla
      phaseChangeObj = this.divisionPhases.find((div: DivisionPhaseDTO) => div.phase == phaseChangeObj.params.phaseChange);
    } else if (phaseChangeObj.params?.phaseChangeArray) {
      let divArray: DivisionPhaseDTO[] = this.divisionPhases.filter(x => phaseChangeObj.params.phaseChangeArray.includes(Number(x.phase)));
      if (divArray && divArray.length > 1 && overlaypanel) {
        this.selectedPhases = divArray;
        overlaypanel.toggle(event);
      } else {
        this.loaded = false;
        this.phase = phaseChangeObj.phase;
        this.division = phaseChangeObj.division;
        this.loadRules();
      }
    }
    if (phaseChangeObj.phase && phaseChangeObj.division) {
      //Es una division
      let divArray: DivisionPhaseDTO[] = this.getPhaseDivisions(phaseChangeObj);
      if (divArray && divArray.length > 1 && overlaypanel) {
        this.selectedPhaseDivision = phaseChangeObj;
        overlaypanel.toggle(event);
      } else {
        this.loaded = false;
        this.phase = phaseChangeObj.phase;
        this.division = phaseChangeObj.division;
        this.loadRules();
      }
    }
  }

  openOptions(event, rule: any, overlaypanel: OverlayPanel) {
    this.selectedRule = rule;
    overlaypanel.toggle(event);
  }

  closeOptions(overlaypanel: OverlayPanel) {
    this.selectedRule = null;
    overlaypanel.hide();
  }

  getActualDivisionPhase(): DivisionPhaseDTO {
    let actualDivisionPhase: DivisionPhaseDTO = this.divisionPhases.find((div: DivisionPhaseDTO) => (div.division == this.division && div.phase == this.phase));
    return actualDivisionPhase;
  }

  actualDivIndex(): number {
    if (!this.divisionPhases)
      return 0;
    let divIndex = this.divisionPhases.findIndex((div: DivisionPhaseDTO) => (div.division == this.division && div.phase == this.phase));
    return divIndex;
  }

  getStartDescriprion(): string {
    return this.phase ? this.getActualDivisionPhase().description : this.translate.instant('General.project');
  }

  getPhases(): DivisionPhaseDTO[] {
    let phases: DivisionPhaseDTO[] = this.divisionPhases.filter((div: DivisionPhaseDTO, index) => (+div.division == 0 || (index > 0 && div.phase != this.divisionPhases[index - 1].phase)));
    return phases;
  }

  getPhaseDivisions(phase: DivisionPhaseDTO): DivisionPhaseDTO[] {
    let divisions: DivisionPhaseDTO[] = this.divisionPhases.filter((div: DivisionPhaseDTO) => (div.phase == phase.phase));
    return divisions;
  }

  isBlankTaskBox(rule: any, taskNum: number): boolean {
    return this.getRuleVisibleTasks(rule).length <= taskNum && taskNum > 0;
  }

  taskClasses(rule: any, taskNum: number): string {
    let clases = "";
    if (this.isBlankTaskBox(rule, taskNum))
      clases += " empty-task";
    let tasks = this.getRuleVisibleTasks(rule);
    if (tasks.length == (taskNum + 1) || (tasks.length == 0 && this.isPhaseChange(rule)))
      clases += " last-not-empty-task";
    if (this.isPhaseChange(rule))
      clases += " phase";
    return clases;
  }

  taskBoxClasses(taskObj: any): string {
    let classes = "";
    if (taskObj instanceof DivisionPhaseDTO || this.isPhaseChange(taskObj))
      classes += " alert alert-warning";
    else if (taskObj.executed && taskObj.executed == "1")
      classes += " alert alert-success";
    else if (taskObj.executed && taskObj.executed == "2")
      classes += " alert alert-info";
    else
      classes += " alert alert-secondary";
    return classes;
  }

  taskExecutedStr(taskObj: any): string {
    if (taskObj.executed == 1)
      return 'Tasks.procedureMap.execution.finished';
    else if (taskObj.executed == 2)
      return 'Tasks.procedureMap.execution.inProcess';
    else
      return 'Tasks.procedureMap.execution.pending';
  }

  isDocClassVisible(docClass: string): boolean {
    return docClass && docClass != "COM_GEN";
  }
}
